// BL-392 auth pill: hollow blue oval; muted when disabled; green with a check on success.
export default function AuthPill({ success = false, successLabel, children, className = '', type = 'button', disabled, ...props }) {
    return <button type={type} disabled={disabled || success} data-state={success ? 'success' : 'idle'}
        className={`ia-auth-pill ${className}`.trim()} {...props}>
        {success ? <><span aria-hidden="true">✓</span>{successLabel || children}</> : children}
    </button>;
}
